import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiErrorDetail } from "@/lib/api";

// Area account temporanea (P03). NON è la Home del prodotto (fuori scope).
export default function AccountArea() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const doLogout = async () => {
    await logout();
    navigate("/login");
  };

  const resend = async () => {
    try {
      await api.post("/auth/resend-verification", { email: user.email });
      toast.success("E-mail di verifica inviata di nuovo.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
  };

  return (
    <AuthShell testid="account-card" title="Il tuo account" subtitle={user?.email}>
      <div className="flex flex-col gap-4">
        <div
          data-testid="account-verified-badge"
          className={`text-center text-sm font-semibold rounded-full py-2 ${
            user?.email_verified
              ? "bg-[#e6f4ea] text-[#2f8a4e]"
              : "bg-[#fdeee7] text-[#c85f45]"
          }`}
        >
          {user?.email_verified ? "E-mail verificata" : "E-mail non verificata"}
        </div>

        {!user?.email_verified && (
          <Button
            data-testid="account-resend-btn"
            variant="outline"
            className="w-full rounded-full py-5 border-[#e0d4c4]"
            onClick={resend}
          >
            INVIA DI NUOVO L’E-MAIL DI VERIFICA
          </Button>
        )}

        <p className="text-xs text-center text-[#9a8f83]">
          Area account temporanea (P03). La Home e l’album arriveranno nelle fasi successive.
        </p>

        <Button
          data-testid="account-logout-btn"
          className="w-full bg-[#2b2622] hover:bg-[#000] text-white rounded-full py-6 text-sm font-semibold"
          onClick={doLogout}
        >
          ESCI DALL’ACCOUNT
        </Button>
      </div>
    </AuthShell>
  );
}
